const AvailabilityStatus = {
  AVAILABLE: 'available',
  BUSY: 'busy',
  PROACTIVE: 'proactive',
  INACTIVE: 'inactive',
};

module.exports = AvailabilityStatus;
